import Layout from "components/layout/Layout";
import {Link} from "react-router-dom";
const PrivacyPolicy = () => {
    return (
        <Layout
            headerStyle={1}
            footerStyle={1}
            breadcrumbTitle={ <> Privacy <span>Policy</span> </> } >
            <section className="job-details-area pb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="job-details-content">
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        At BodyLytiX, your privacy is our commitment. We collect and use data responsibly, ensuring compliance with global standards like GDPR. You control your data and can request deletion at any time. For more information, contact us at <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>1. Information We Collect</strong>
                                    <p>
                                    We collect information to provide and improve our Services. This includes:
                                    </p>
                                    <strong>A. Information You Provide Directly</strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Account Information:  
                                            </strong>
                                            <span> Name, email address, date of birth, gender, and other registration details.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Fitness Data: 
                                            </strong>
                                            <span> Goals, preferences, and inputs such as weight, height, and activity metrics.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Payment Information:  
                                            </strong>
                                            <span> Billing address and payment method (processed securely by third-party payment providers).</span>
                                        </li>
                                    </ul>
                                    <strong>B. Information We Collect Automatically</strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>
                                                Device Information:
                                            </strong>
                                            <span> IP address, browser type, operating system, and device identifiers.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Usage Data: 
                                            </strong>
                                            <span> Interactions with the app, such as feature usage, time spent, and error logs.</span>
                                        </li>
                                        <li>
                                            <strong>
                                                Location Data: 
                                            </strong>
                                            <span> When enabled, we may collect location information to enhance your experience (e.g., local fitness trends).</span>
                                        </li>
                                    </ul>
                                    <strong>C. Information from Third-Party Integrations</strong>
                                    <p>
                                        <span> If you connect BodyLytiX to Garmin, Apple Health, or other third-party services, we collect data shared by these platforms, such as step counts, heart rate, and workout details.</span>
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>2. How We Use Your Information</strong>
                                    <p>
                                        We use your information to:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            Provide and personalize your BodyLytiX experience.
                                        </li>
                                        <li>
                                            Generate insights and recommendations tailored to your fitness goals.
                                        </li>
                                        <li>
                                            Maintain and improve our Services.
                                        </li>
                                        <li>
                                            Communicate updates, promotions, or changes to our Services.
                                        </li>
                                        <li>
                                            Comply with legal obligations and prevent fraud.
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>3. How We Share Your Information</strong>
                                    <p>
                                    We respect your privacy and only share your data under the following circumstances:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                        <strong>With Your Consent: </strong>
                                        For example, sharing your progress with other users.
                                        </li>
                                        <li>
                                            <strong>Service Providers: </strong>
                                            Trusted third parties that support our operations, such as cloud hosting and
                                        </li>
                                        <li>
                                            <strong>Compliance and Legal Requirements: </strong>
                                            If required by law or to protect the rights and safety of our users and platform.
                                        </li>
                                        <li>
                                            <strong>Anonymized Data: </strong>
                                            Aggregated and anonymized data may be used for research, product development, or marketing.
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>4. Data Storage and Security</strong>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            <strong>Data Residency: </strong>
                                            Your data is stored securely on AWS servers in compliance with regional regulations.
                                        </li>
                                        <li>
                                            <strong>Encryption: </strong>
                                            We use encryption to protect your data in transit and at rest.
                                        </li>
                                        <li>
                                            <strong>Access Control: </strong>
                                            Access to personal data is limited to authorized personnel.
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>5. Your Privacy Choices</strong>
                                    <p>
                                        You control your data. You can:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            Update your account information.
                                        </li>
                                        <li>
                                            Manage third-party integrations.
                                        </li>
                                        <li>
                                            Opt-out of promotional emails.
                                        </li>
                                        <li>
                                            Delete your account and request the removal of your data by contacting <a href="mailto:support@bodylytix.ai">
                                                support@bodylytix.ai
                                            </a>.
                                        </li>
                                    </ul>
                                </div>
                                <div className="job-qualifications">
                                    <strong>6. Cookies and Tracking Technologies</strong>
                                    <p>
                                        We use cookies and similar technologies to:
                                    </p>
                                    <ul style={{ marginTop: "10px" }}>
                                        <li>
                                            Improve site functionality and performance.
                                        </li>
                                        <li>
                                            Analyze usage patterns.
                                        </li>
                                        <li>
                                            Deliver personalized content and advertisements.
                                        </li>
                                    </ul>
                                    <p>
                                        You can manage cookie preferences through your browser settings.
                                    </p>
                                </div>
                                <hr></hr>
                                <div className="job-qualifications">
                                    <strong>7. Children's Privacy</strong>
                                    <p>
                                        BodyLytiX is not intended for individuals under 18. We do not knowingly collect data from children. If you believe a child has provided personal information, contact us at <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>, and we will promptly delete it.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>8. International Users</strong>
                                    <p>
                                        By accessing BodyLytiX, you agree to the processing of your data in the countries where we operate. Data may be transferred to and stored in regions with different privacy laws.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>9. Changes to This Privacy Policy</strong>
                                    <p>
                                        We may update this Privacy Policy periodically. Significant changes will be communicated via email or through the app. Continued use of our Services after updates constitutes acceptance of the revised policy.
                                    </p>
                                </div>
                                <div className="job-qualifications">
                                    <strong>10. Contact Us</strong>
                                    <p>
                                        If you have questions or concerns about this Privacy Policy or how we handle your data, contact us at:
                                    </p>
                                    <div>
                                        <strong>
                                            Email: &nbsp;
                                        </strong>
                                        <a href="mailto:support@bodylytix.ai">
                                            support@bodylytix.ai
                                        </a>
                                    </div>
                                    <div>
                                        <strong>
                                            Website: &nbsp;
                                        </strong>
                                        <a href="https://www.bodylytix.ai/">
                                            www.bodylytix.ai
                                        </a>
                                    </div>
                                    <div>
                                        <strong>Contact Form: </strong>
                                        <span>
                                          <Link to="/contact">
                                            contact us
                                          </Link>
                                        </span>
                                    </div>
                                </div>
                                <div className="job-qualifications">
                                    <p className="info-one">
                                        By using BodyLytiX, you consent to this Privacy Policy. Thank you for trusting us with your fitness and wellness journey!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    );
};
export default PrivacyPolicy;